// src/hooks/useInvoiceData.ts
import { useState, useEffect } from 'react';
import { handleApiError } from '../utils/api';
import { API_BASE_URL } from '../constants/api';
import { InvoiceProps } from '../types/invoice';

export const useInvoiceData = (
    studentId: number | undefined,
    kaishaId: number,
    seikyuMonth: string,
    token: string
) => {
    const [invoiceProps, setInvoiceProps] = useState<InvoiceProps | null>(null);
    const [months, setMonths] = useState<{ display: string; value: string }[]>(
        []
    );

    const fetchInvoiceData = async (month: string) => {
        try {
            const response = await fetch(
                `${API_BASE_URL}/fees/${studentId}/${kaishaId}/${month}`,
                {
                    headers: {
                        Authorization: 'Bearer ' + token,
                    },
                }
            );
            const data = await response.json();
            setInvoiceProps(data);
        } catch (error) {
            handleApiError(error);
        }
    };

    const fetchMonths = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/fees/monthList`, {
                headers: {
                    Authorization: 'Bearer ' + token,
                },
            });
            const data = await response.json();
            const formattedMonths = data.map(
                (month: { id: string; disp: string; value: string }) => ({
                    display: month.value,
                    value: month.id,
                })
            );
            setMonths(formattedMonths);
        } catch (error) {
            handleApiError(error);
        }
    };

    useEffect(() => {
        fetchInvoiceData(seikyuMonth);
        fetchMonths();
    }, [seikyuMonth]);

    return { invoiceProps, months, fetchInvoiceData };
};
